import { baseDefaultDocumentationConfiguration, internalMergeDocumentationConfigurations, } from "@dataspecer/documentation";
import { defaultJsonPartials } from "@dataspecer/json/documentation";
import { defaultXmlPartials } from "@dataspecer/xml/documentation";
/**
 * Default, complete configuration for the documentation generator.
 */
export const defaultDocumentationConfiguration = {
    ...baseDefaultDocumentationConfiguration,
    partials: {
        ...baseDefaultDocumentationConfiguration.partials,
        ...defaultJsonPartials,
        ...defaultXmlPartials,
    },
};
/**
 * Merges documentation configurations. It already includes the default configuration.
 * @returns Complete configuration for the documentation generator.
 */
export function mergeDocumentationConfigurations(configurations) {
    return internalMergeDocumentationConfigurations([defaultDocumentationConfiguration, ...configurations]);
}
/**
 * List of partial names that belongs to generators.
 */
export const documentationPartialsFromGenerators = [
    ...Object.keys(defaultJsonPartials),
    ...Object.keys(defaultXmlPartials),
];
//# sourceMappingURL=documentation.js.map